import { RestrictedAPI } from '@fnol/library/src/api';
import { GenericObject } from '@fnol/library/src/lib';
import * as endpoints from './endpoints';

export const getCountries = () => RestrictedAPI.get(endpoints.countries());
export const getCitizenships = () => RestrictedAPI.get(endpoints.citizenship());
export const getCities = () => RestrictedAPI.get(endpoints.cities());
export const getPolicyDetails = (data: GenericObject) => RestrictedAPI.post(endpoints.policyDetails(), data);
export const getPoliciesList = (data: GenericObject) => RestrictedAPI.post(endpoints.policiesList(), data);
export const getPoliciesListForPortal = () => RestrictedAPI.get(endpoints.policiesListForPortal());
export const getBankAccounts = () => RestrictedAPI.get(endpoints.bankAccounts());
export const getInsuredTypes = () => RestrictedAPI.get(endpoints.insuredTypes());
export const submitTemporaryData = (data: GenericObject) => RestrictedAPI.post(endpoints.claimSubmit(), data);
export const getClaimConfirmation = (data: any) => RestrictedAPI.post(endpoints.claimConfirmation(), data);
export const getClaimConfirmationAnonymous = (data: any) =>
    RestrictedAPI.post(endpoints.claimConfirmationAnonymous(), data);
export const getDocList = (id: string) => RestrictedAPI.get(endpoints.documents(id));
export const submitDocuments = (data: any) => RestrictedAPI.post(endpoints.addDocuments(), data);
export const getUserData = () => RestrictedAPI.get(endpoints.userData());
export const sendOneTimePassword = (data: any) => RestrictedAPI.post(endpoints.oneTimePassword(), data);
export const getUsersList = (data: GenericObject) => RestrictedAPI.post(endpoints.usersList(), data);
export const getContractorData = (data: GenericObject) => RestrictedAPI.post(endpoints.contractorData(), data);
export const getOfferValidation = (data: any) => RestrictedAPI.post(endpoints.offerValidation(), data);
